import React, { type ReactElement, type ReactNode } from 'react';
import cx from 'classnames';

import { SodFooter } from '../../../shared/components';

import './DetailsFooter.css';

interface DetailsFooterProps {
  content: ReactNode;
  isVisible: boolean;
}

/**
 * DetailsFooter
 *
 * TODO:
 * - Localize the buttons
 * - Conditionally render this footer based on the page
 */
function DetailsFooter({
  content,
  isVisible,
}: DetailsFooterProps): ReactElement {
  const sodFooterClasses = cx(
    'Sod-DetailsFooter',
    isVisible && 'Sod-DetailsFooter--isVisible'
  );

  return (
    <SodFooter dataTheme='light' className={sodFooterClasses}>
      {content}
    </SodFooter>
  );
}

export default DetailsFooter;
